<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" temporary app right v-if="user">
      <v-card class="mx-auto" max-width="434" tile>
        <v-img height="100%" src="/img/title.png">
          <v-row align="end" class="fill-height">
            <v-col class="py-0">
              <v-list-item color="rgba(0, 0, 0, .4)" dark>
                <v-list-item-content>
                  <v-list-item-title class="title">{{ personal.prenume }} {{ personal.nume }}</v-list-item-title>
                  <!-- <v-list-item-subtitle>TUD Group</v-list-item-subtitle> -->
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </v-img>
      </v-card>
      <v-list dense>
        <v-list-item to="Home">
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Pagina principala</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="Admin" v-if="user.role === 'admin'">
          <v-list-item-action>
            <v-icon>mdi-shield-account</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Administrare</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="Personal" v-if="!['evaluator', 'el presidente'].includes(user.role)">
          <v-list-item-action>
            <v-icon>mdi-account</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Detalii Personale</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="Form" v-if="!['evaluator', 'el presidente'].includes(user.role)">
          <v-list-item-action>
            <v-icon>mdi-form-select</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Completeaza formular</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="Formeval" v-if="user.role !== 'aplicant'">
          <v-list-item-action>
            <v-icon>mdi-magnify</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Evaluare</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="!['evaluator', 'el presidente'].includes(user.role) && !user.contestatii" style="cursor: pointer" disabled>
          <v-list-item-action>
            <v-icon color="error">mdi-alert-decagram</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-dialog v-model="dialog" width="500">
              <template v-slot:activator="{ on }">
                <v-list-item-title v-on="on">Contestatie</v-list-item-title>
              </template>

              <v-card raised class="pa-md-4 mx-lg-auto">
                <v-card-title>
                  <div>Depunere contestatie</div>
                  <v-spacer></v-spacer>
                  <v-btn icon color="error" @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-text>
                  <v-form ref="form" lazy-validation>
                    <v-textarea v-model="text" outlined label="Descriere contestatie" :rules="[val => !!val || 'Trebuie sa completati acest camp']"></v-textarea>
                    <v-file-input
                      v-model="file"
                      label="Fisierul pentru contestatie">
                    </v-file-input>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="createAppeal" color="primary" disabled>Trimiteti</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="About">
          <v-list-item-action>
            <v-icon>mdi-information</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Despre Platforma</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="white">
      <v-toolbar-title>S.E.S. – Solidaritate, Egalitate, Sustenabilitate</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn :to="{ path: '/' }" text exact>
          <v-icon left>mdi-home</v-icon>
          <span v-if="!['xs'].includes($vuetify.breakpoint.name)">
            Acasa
          </span>
        </v-btn>
        <v-btn :to="{ path: '/about' }" text exact>
          <v-icon left>mdi-information-variant</v-icon>
          <span v-if="!['xs'].includes($vuetify.breakpoint.name)">
            Despre proiect
          </span>
        </v-btn>
        <v-btn :to="{ path: '/contact' }" text exact>
          <v-icon left>mdi-card-account-mail</v-icon>
          <span v-if="!['xs'].includes($vuetify.breakpoint.name)">
            Contact
          </span>
        </v-btn>
        <v-btn @click="signOut(true)" text v-if="user" exact>
          <v-icon left>mdi-logout-variant</v-icon>
          <span v-if="!['xs'].includes($vuetify.breakpoint.name)">
            Iesire
          </span>
        </v-btn>
        <v-btn @click="signOut(false)" :to="{ name: 'Signin' }" text v-else exact>
          <v-icon left>mdi-account</v-icon>
          <span v-if="!['xs'].includes($vuetify.breakpoint.name)">
            Autentificare
          </span>
        </v-btn>

        <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      </v-toolbar-items>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>

    <v-container>
      <v-row>
        <v-col cols="12" class="mb-10">
          <p class="text-h5 text-center">Parteneri</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="4" sm="12" class="mb-10">
          <div class="d-flex justify-center">
            <a href="https://asociatiaeuropas.ro/" target="_blank">
              <v-img
                :src="require('@/assets/europas.png')"
                class="mx-auto"
                contain
                max-width="50%"
                max-height="150px">
              </v-img>
            </a>
          </div>
        </v-col>
        <v-col md="4" sm="12" class="mb-10">
          <div class="d-flex justify-center">
            <a href="https://www.acm.info.ro/" target="_blank">
              <v-img
                :src="require('@/assets/acm.jpg')"
                class="mx-auto"
                contain
                max-width="50%"
                max-height="150px">
              </v-img>
            </a>
          </div>
        </v-col>
        <v-col md="4" sm="12" class="mb-10">
          <div class="d-flex justify-center">
            <a href="http://addwise.eu/ro.html" target="_blank">
              <v-img
                :src="require('@/assets/addwise.png')"
                class="mx-auto"
                contain
                max-width="50%"
                max-height="150px">
              </v-img>
            </a>
          </div>
        </v-col>
        <v-col cols="12" class="mb-10">
          <p class="text-caption text-center">
            „Conţinutul acestui material nu reprezintă în mod obligatoriu poziţia oficială a Uniunii Europene sau a Guvernului României”
          </p>
        </v-col>
      </v-row>
    </v-container>
    <!-- <v-footer app color="white">
      <v-container fluid>
        <v-row no-gutters>
          <v-col cols="12" class="text-right" style="display: flex; align-items: center; justify-content: flex-end">
            <span class="text-caption mr-2">powered by</span>
            <a href="https://tudconsult.ro/" target="_blank" class="text-subtitle-2 text-decoration-none">TUD Group | Verde Smart Data</a>
            <img :src="require('@/assets/logo-tud.png')" height="18" width="18" class="ml-1">
          </v-col>
        </v-row>
      </v-container>
    </v-footer> -->
  </v-app>
</template>

<script>
export default {
  name: "Layout",
  data: () => ({
    drawer: false,
    dialog: false,
    files: [],
    fileUrl: "",
    file: null,
    text: ""
  }),
  computed: {
    user() {
      return this.$store.getters.user;
    },
    personal() {
      return this.$store.getters.personal;
    }
  },
  methods: {
    signOut(redirect = false) {
      if (redirect) this.$router.push({ name: "Home" });
      this.$store.dispatch("signOut");
    },

    createAppeal() {
      /* eslint-disable no-unreachable */
      return;
      const valid = this.$refs.form.validate();

      if (valid) {
        const appealData = {
          text: this.text,
          file: this.file
        };
        this.$store.dispatch("createAppeal", appealData);
        this.closeDialog();
      }
    },
    closeDialog() {
      this.dialog = false;
      this.$refs.form.reset();
    },
    onFilePicked(event) {
      let files = event.target.files[0];
      let filename = files[0].name;

      if (filename.lastIndexOf(".") <= 0) {
        return alert("SSSSSSSSSSS");
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.fileUrl = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.file = files[0];
    }
  }
};
</script>

<style lang="stylus">
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

.break-all {
  word-break: break-all;
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
